// import React from 'react';
// import { Box, Typography } from '@mui/material';

// const TopHeader = () => {
//   return (
//     <Box
//       sx={{
//         position: 'sticky',
//         top: 0,
//         width: '100%',
//         height: '44px',
//         zIndex: 1200,
//         boxSizing: 'border-box',

//         backgroundColor: '#F8F7F4',

//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'flex-start',

//           width: '100%',
//           height: '44px',

//           px: 2,
//           boxSizing: 'border-box',
//         }}
//       >
//         <Typography
//           variant="subtitle1"
//           sx={{
//             color: 'rgb(0, 0, 0)',
//             fontWeight: 'bold',
//             fontFamily: "'Cinzel', serif",
//             letterSpacing: 0.5,
//             fontSize: {
//               xs: '0.9rem',
//               sm: '1.1rem',
//             },
//           }}
//         >
//           PROPERTY PINCODER
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default TopHeader;


import React from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../../Users/Dashboard/Images/logo-main.jpeg'; // Update this path

const TopHeader = () => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        width: '100%',
        height: '44px',
        zIndex: 1200,
        boxSizing: 'border-box',
        backgroundColor: '#F8F7F4',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: '44px',
          px: 2,
          boxSizing: 'border-box',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: 'rgb(0, 0, 0)',
            fontWeight: 'bold',
            fontFamily: "'Cinzel', serif",
            letterSpacing: 0.5,
            fontSize: {
              xs: '0.9rem',
              sm: '1.1rem',
            },
          }}
        >
          PROPERTY PINCODER
        </Typography>

        {/* ✅ Logo - Fixed for mobile clarity */}
        <Box
          component="img"
          src={logo}
          alt="Company Logo"
          sx={{
            height: '45px',              // ✅ Fits inside 44px header with breathing room
            maxHeight: '100%',
            width: 'auto',
            maxWidth: '120px',
            objectFit: 'contain',
            display: 'block',
            // ✅ Prevents mobile webview from blurring the image
            imageRendering: '-webkit-optimize-contrast',
            // ✅ Prevents sub-pixel rendering blur on some Android devices
            transform: 'translateZ(0)',
            backfaceVisibility: 'hidden',
            // ✅ Ensures sharp scaling on retina/high-DPI screens
            WebkitBackfaceVisibility: 'hidden',
          }}
        />
      </Box>
    </Box>
  );
};

export default TopHeader;